module.exports = __webpack_public_path__ + "static/CollectiveRooftopTerrace-mobile-596fdbfc34ef7f20195bd18eb7287f48.jpg";